
import {
	Model,
	IModelAttributes,
	attribute,
	entity,
} from 'Models/Model';
import * as Models from 'Models/Entities';
import { IAcl } from '../Security/IAcl';
import { observable } from 'mobx';
import UserOrganisationprovider from '../Security/Acl/UserOrganisationprovider';
import VisitorsOrganisationprovider from '../Security/Acl/VisitorsOrganisationprovider';


export interface IOrganisationProviderAttributes extends IModelAttributes {
	organisationId: string;
	providerId: string;
	enabled: boolean;
	organisation: Models.OrganisationEntity | Models.IOrganisationEntityAttributes;
	provider: Models.ProviderEntity | Models.IProviderEntityAttributes;
}

@entity('OrganisationProvider')
export default class OrganisationProvider
	extends Model
	implements IOrganisationProviderAttributes {
	public static acls: IAcl[] = [
		new UserOrganisationprovider(),
		new VisitorsOrganisationprovider(),
	];

	@observable
	@attribute()
	public organisationId: string;

	@observable
	@attribute()
	public providerId: string;

	@observable
	@attribute()
	public enabled: boolean;

	@observable
	@attribute({ isReference: true })
	public organisation: Models.OrganisationEntity;

	@observable
	@attribute({ isReference: true })
	public provider: Models.ProviderEntity;


	constructor(attributes?: Partial<IOrganisationProviderAttributes>) {

		super(attributes);

		if (attributes) {
			if (attributes.organisationId) {
				this.organisationId = attributes.organisationId;
			}
			if (attributes.providerId) {
				this.providerId = attributes.providerId;
			}

			if (attributes.organisation) {
				if (attributes.organisation instanceof Models.OrganisationEntity) {
					this.organisation = attributes.organisation;
					this.organisationId = attributes.organisation.id;
				} else {
					this.organisation = new Models.OrganisationEntity(attributes.organisation);
					this.organisationId = this.organisation.id;
				}
			} else if (attributes.organisationId !== undefined) {
				this.organisationId = attributes.organisationId;
			}

			if (attributes.provider) {
				if (attributes.provider instanceof Models.ProviderEntity) {
					this.provider = attributes.provider;
					this.providerId = attributes.provider.id;
				} else {
					this.provider = new Models.ProviderEntity(attributes.provider);
					this.providerId = this.provider.id;
				}
			} else if (attributes.providerId !== undefined) {
				this.providerId = attributes.providerId;
			}
		}
	}
}
